import React from "react";

export default function Footer() {
  return (
    <>
      <div className="footer-container">
        <div className="border bottom-side"></div>

        <footer className="footer" id="contact">
          <div className="container footer--grid footer--grid--2-cols">
            <div className="logo-col">
              <div className="footer--logo-btn">
                <a className="btn btn-two" href="/#">
                  <img
                    className="logo-img"
                    src="/images/my-logo.png"
                    alt="Jayant Arora logo"
                  />
                </a>
              </div>

              <ul className="social-links">
                <li>
                  {/* https://www.instagram.com/jayanttarora */}
                  <a
                    className="footer-link"
                    href="https://www.instagram.com/jayanttarora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ion-icon
                      className="social-icon"
                      name="logo-instagram"
                    ></ion-icon>
                  </a>
                </li>

                <li>
                  <a
                    className="footer-link"
                    href="https://www.facebook.com/jayanttarora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ion-icon
                      className="social-icon"
                      name="logo-facebook"
                    ></ion-icon>
                  </a>
                </li>
                <li>
                  <a
                    className="footer-link"
                    href="https://www.linkedin.com/in/jayantarora63"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ion-icon
                      className="social-icon"
                      name="logo-linkedin"
                    ></ion-icon>
                  </a>
                </li>
                <li>
                  <a
                    className="footer-link"
                    href="https://github.com/jayanttArora"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ion-icon
                      className="social-icon"
                      name="logo-github"
                    ></ion-icon>
                  </a>
                </li>
              </ul>

              {/* <p className="copyright">
            Copyright &copy; <span className="year">2027</span> by Omnifood, Inc.
            All rights reserved.
          </p> */}
            </div>
            <div className="address-col">
              <p className="footer-heading">Want to connect?</p>
              <address className="contacts">
                <p className="address">Let&rsquo;s do it</p>
                <p className="contact-dtls">
                  <a className="footer-link" href="tel:+91-8630763261">
                    +91-8630763261
                  </a>
                  <br />
                  <a
                    className="footer-link"
                    href="mailto:jayantarora63@gmail.com"
                  >
                    jayantarora63@gmail.com
                  </a>
                </p>
              </address>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
